import React from 'react';
import HistologiaPage from './histologia.page';
function Histologia () {
  return <HistologiaPage />;
}

export default Histologia;



// WEBPACK FOOTER //
// ./src/pages/histologia/histologia.container.js